import {NgModule} from "@angular/core";
import {TranslatePipe} from "./translate.pipe";
import {TruncatePipe} from './truncate.pipe';
import { DurationPipe } from './duration.pipe';
import {HumanDatePipe} from './human-date.pipe';
import {MomentDatePipe} from "./moment-date.pipe";

@NgModule({
    imports: [],
    declarations: [
        TranslatePipe,
        TruncatePipe,
        DurationPipe,
        HumanDatePipe,
        MomentDatePipe
    ],
    exports: [
        TranslatePipe,
        TruncatePipe,
        DurationPipe,
        HumanDatePipe,
        MomentDatePipe
    ]
})

export class CommonPipesModule {}
